export const recommendations = [
    {
        id: 'recommendationlist11',
        title: 'Missed Intros',
        asset: 'New Hire Training - Refresher',
        link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
    },
    {
        id: 'recommendationlist12',
        title: 'Missed Intros',
        asset: 'CSAT Champions Call #1',
        link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
    },
    {
        id: 'recommendationlist13',
        title: 'Missed Intros',
        asset: 'CSAT Champions Call #2',
        link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
    },
    {
        id: 'recommendationlist14',
        title: 'Missed Intros',
        asset: 'Language Best Practices',
        link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
    },
    {
        id: 'recommendationlist15',
        title: 'Missed Intros',
        asset: 'Sample Practice Script',
        link: 'https://www.google.com/',
    }
]